const handleAddFileUploader = async (
  file,
  uploaderAddFile,
  addToast,
  getTextByKey,
  relativePath,
  tooManyVideos
) => {
  const metaObj = {};

  if (relativePath && relativePath !== file.name) {
    metaObj.relativePath = relativePath.replaceAll("/", "\\\\");
  }

  try {
    await uploaderAddFile(
      {
        source: "file input",
        name: file.name,
        type: file.type,
        data: file,
        meta: metaObj,
      },
      tooManyVideos
    );
  } catch (err) {
    if (err.isRestriction) {
      // handle restrictions
      if (err.message.includes("it already exists")) {
        addToast(getTextByKey("file-already-exist-message"), {
          appearance: "error",
          autoDismiss: true,
          type: "file-exist",
        });
      }
    } else {
      // handle other errors
      console.error(err);
    }
  }
};

export default handleAddFileUploader;
